import { Figure } from './figure'
import { Algorithm } from '../algorithm'
import { ModelTransformersPackage } from '../transformer'
import { Comparisons } from './comparison'
import { Influences } from './influence'
import { ModelStatus } from '../enum'

export let UploadFileInfo = {
  dsName: '',
  fileSizeByte: 0,
  fileName: '',
  originalDsName: '',
  originalFileName: '',
  originalFileSizeByte: 0,
  isJoined: false,
  importId: '',
  importedAt: ''
}

export let DataSourceInfo = {
  dsName: '',
  header: [],
  uploadFiles: [],
  rsName: '',
  rsCount: 0
}

export let RawSourceInfo = {
  dsName: '',
  rsName: '',
  rsCount: 0,
  uploadFiles: []
}

export let XTypeInfo = {
  name: '',
  type: ''
}

export let Possibility = {
  name: '',
  prefecture: 0,
  regionCode: 0,
  standardNumber: 0
}

export let Remarks = {
  naviType: '',
  evaluationData: '',
  transformerPackageId: ''
}

export let ModelInfo = {
  modelId: '',
  modelName: '',
  categoryId: '',
  ds: DataSourceInfo,
  yName: '',
  xName: [],
  xType: [],
  xExcept: [],
  figureSummaryId: '',
  figureDetailId: '',
  transformerPackage: ModelTransformersPackage,
  algorithm: Algorithm,
  updatedAt: '',
  samples: 0,
  deleteUploadFile: false,
  figureSummary: Figure,
  figureDetail: Figure,
  remarks: Remarks,
  possibilities: [],
  dataCollections: []
}

export let ModelDetailInfo = {
  type: '',
  modelId: '',
  modelName: '',
  categoryId: '',
  ds: DataSourceInfo,
  yName: '',
  xName: [],
  xType: [],
  xExcept: [],
  figureSummaryId: '',
  figureDetailId: '',
  transformerPackage: ModelTransformersPackage,
  algorithm: Algorithm,
  algorithmName: '',
  algorithmVersion: 0,
  updatedAt: '',
  samples: 0,
  samplesTrain: 0,
  trainRate: 0,
  yletes: [],
  yletSizes: [],
  structure: '',
  evaluations: [],
  comparisons: Comparisons,
  influences: {},
  trainInterval: ['', ''],
  deleteUploadFile: false,
  remarks: Remarks

}

export let PredictResultPreviewResult = {
  id: '',
  value: {
    name: '',
    value: 0
  }
}

export let PredictResultPreview = {
  idName: '',
  header: [],
  results: []
}

export let PredictResult = {
  modelId: '',
  resultFile: '',
  resultPreview: PredictResultPreview,
  resultCount: 0,
  updatedAt: '',
  remarks: {
    confidenceInterval: ['', '']
  },
  predict: '',
  confidenceInterval: []
}

export let PredictResultListValue = {
  predictId: '',
  key: '',
  updatedAt: '',
  count: 0,
  statusCode: ModelStatus,
  resultFile: ''
}

export let PredictEvaluationValue = {
  predictEvaluationId: '',
  key: '',
  updatedAt: '',
  count: 0,
  statusCode: ModelStatus,
  evaluations: {}
}

export let PredictEvaluationResult = {
  modelEvaluations: [],
  predictEvaluation: PredictEvaluationValue
}

export let PredictEvaluationsResult = {
  modelEvaluations: [],
  predictEvaluations: []
}

export let XTypeDef = {
  label: '',
  value: ''
}

export const X_TYPE_DEFINE = [
  { label: '数値', value: 'numeric' },
  { label: 'カテゴリー', value: 'category' },
  { label: 'テキスト', value: 'text' },
  { label: '日時', value: 'time' }
]



// WEBPACK FOOTER //
// ./src/defines/model/model.js